/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Extraction } from './Extraction.js';
import {
    ExtractionFromJSON,
    ExtractionFromJSONTyped,
    ExtractionToJSON,
} from './Extraction.js';
import type { SearchTrigger } from './SearchTrigger.js';
import {
    SearchTriggerFromJSON,
    SearchTriggerFromJSONTyped,
    SearchTriggerToJSON,
} from './SearchTrigger.js';

/**
 * 
 * @export
 * @interface Search
 */
export interface Search {
    /**
     * 
     * @type {number}
     * @memberof Search
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Search
     */
    contactId?: number;
    /**
     * 
     * @type {Extraction}
     * @memberof Search
     */
    extraction?: Extraction;
    /**
     * 
     * @type {SearchTrigger}
     * @memberof Search
     */
    trigger?: SearchTrigger;
    /**
     * 
     * @type {number}
     * @memberof Search
     */
    fieldId?: number;
    /**
     * 
     * @type {string}
     * @memberof Search
     */
    query?: string;
}

/**
 * Check if a given object implements the Search interface.
 */
export function instanceOfSearch(value: object): boolean {
    return true;
}

export function SearchFromJSON(json: any): Search {
    return SearchFromJSONTyped(json, false);
}

export function SearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Search {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'extraction': json['extraction'] == null ? undefined : ExtractionFromJSON(json['extraction']),
        'trigger': json['trigger'] == null ? undefined : SearchTriggerFromJSON(json['trigger']),
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'query': json['query'] == null ? undefined : json['query'],
    };
}

export function SearchToJSON(value?: Search | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'contactId': value['contactId'],
        'extraction': ExtractionToJSON(value['extraction']),
        'trigger': SearchTriggerToJSON(value['trigger']),
        'fieldId': value['fieldId'],
        'query': value['query'],
    };
}

